<!-- eslint-disable -->
<template lang="pug">
    .play-box.vision-field-game-container
        .play-box__game(v-if='!isLoading')
            game-preparation-counter(v-if="counter < 4 && !gameStarted", :counter="counter")
            game-header(
                @soundStateChanged="headerKey = !headerKey",
                :key="headerKey",
                :slug="type",
                game-type="fastReading",
                :is-homework="!!exerciseId",
            )
            .vision-field-game-container__divider
            .vision-field-game-container__interactive-place(v-show='gameStarted && !gameFinished')
                .vision-field-game-container__game(v-show='isRunning')
                    .vision-field-game-container__game-info
                        game-info(
                            :score="{left: answers.good, right: answers.bad}"
                            :time="getTime"
                            :is-olympiad="isOlympiad"
                        )
                    .vision-field-game-container__game-box(v-show='showItem')
                        .vision-field-game-container__game-box__leftPart
                            | {{ getLeftPart }}
                        .vision-field-game-container__game-box__centralPart(:style='`width: ${widthGameBoxCenter}`') ◑
                        .vision-field-game-container__game-box__rightPart
                            | {{ getRightPart }}
                    .vision-field-game-container__answer-form(v-if='showAnswerForm')
                        .vision-field-game-container__answer-header
                            | {{ $i18n.t('trainer.trainer_gamePlayBox_enterTheAnswer') }}
                        .vision-field-game-container__answer-body
                            .vision-field-game-container__input
                                cs-input(
                                    ref='input',
                                    @keyup.native.enter='processReply',
                                    v-model='answer',
                                    v-focus="true",
                                )
                        .vision-field-game-container__answer-footer
                            cs-button(@click='processReply', color="blue", type="button")
                                | {{ $i18n.t('trainer.trainer_gamePlayBox_reply') }}
                .vision-field-game-container__reaction-container(v-if='!isRunning')
                    result-image.vision-field-game-container__reaction-image(:status="correct ? 'success' : 'failure'")
                    template(v-if='!gameFinished')
                        cs-button(
                            v-if='correct',
                            v-focus='true',
                            @click='refreshGame',
                            color="blue",
                        )
                            | {{ $i18n.t('trainer.trainer_gamePlayBox_playOn') }}
                        cs-button(
                            v-else,
                            v-focus='true',
                            @click='refreshGame',
                            color="blue",
                        )
                            | {{ $i18n.t('trainer.trainer_games_tryAgain') }}
            template(v-if='gameFinished && !isOlympiad')
                .vision-field-game-container__reaction-container
                    .vision-field-game-container__reaction
                        .vision-field-game-container__reaction-side.vision-field-game-container__reaction-side--correct
                            div
                                | {{ $i18n.t('trainer.trainer_gamePlayBox_correct') }}
                            .vision-field-game-container__reaction-count
                                | {{ answers.good }}
                        .vision-field-game-container__reaction-image-container
                            result-image.vision-field-game-container__reaction-image(:status="'success'")
                        .vision-field-game-container__reaction-side
                            div
                                | {{ $i18n.t('trainer.trainer_gamePlayBox_wrong') }}
                            .vision-field-game-container__reaction-count
                                | {{ answers.bad }}
                    result-buttons(
                        :exercise-id="exerciseId"
                        games-type="fastReading"
                        show-restart-button
                        @restartGame="restartGame"
                    )
                        slot
        cs-loader(v-else)
</template>

<script>
    /*eslint-disable*/
    import _ from 'lodash';
    import VisionFieldApi from '../../../../api/games/visionField';
    import playBoxGameMixin from '../../../../utils/trainer/playBoxGameMixin.js';
    import olympiadAnswerTimerMixin from '../../../../utils/olympiads/olympiadAnswerTimerMixin.js';

    function DEFAULT_DATA () {
        return {
            isRunning: true,
            answer: '',
            correct: false,
            showItem: true,
            showAnswerForm: false,
            currentPadding: 0,
            items: [],
            answers: {
                good: 0,
                bad: 0,
            },
            lastAnswer: {
                good: 0,
                bad: 0,
            },
        }
    }

    export default {
        mixins: [playBoxGameMixin, olympiadAnswerTimerMixin],
        data () {
            return DEFAULT_DATA();
        },
        computed: {
            correctAnswer() {
                let result = this.items.length ? this.items[0] : '';
                if(this.parameters.mode === 'words' && typeof result === 'object') {
                    result = result.word;
                }
                return result && result.toLowerCase();
            },
            getLeftPart () {
                return this.correctAnswer ? this.correctAnswer.slice(0, this.parameters.difficult.value/2) : '';
            },
            getRightPart () {
                return this.correctAnswer ? this.correctAnswer.slice(this.parameters.difficult.value/2) : '';
            },
            widthGameBoxCenter() {
                if(this.windowWidth > 250) {
                    return `calc(${this.currentPadding}% + 30px)`;
                }
                return '30px';
            },
        },
        watch: {
            isRunning: {
                handler (val) {
                    this.$emit('checkAnswersReady', val);
                },
                immediate: true
            },
        },
        methods: {
            fetchData() {
                this.getExercise().then(() => {
                    if (this.parameters.mode === 'words') {
                        VisionFieldApi.getWords({
                            locale: this.user.locale,
                            length: this.parameters.difficult.value,
                            limit: this.parameters.numOfExamples - this.answers.good
                        })
                        .then(data => {
                            this.items = Object.values(data).map(word => {
                                word.word = word.word.replace('&#x301;', '');
                                return word;
                            });
                            this.registerSounds();
                        })
                        .catch(err => this.showErrorMessage(err));
                    } else {
                        this.generateNumbers();
                        this.registerSounds();
                    }
                })
                .catch(e => {
                    this.isLoading = false;
                    this.$toasted.error(this.$root.$t('errors.getting_level'));
                    this.$router.push({ name: 'dashboard' });
                });
            },
            beforeStart () {
                this.startGame();
            },
            startGame () {
                this.gameStarted = true;
                this.changeDistance(this.parameters.startDistance);
                for (let i = 0; i < this.answers.good; i++) {
                    this.changeDistance(this.parameters.distanceIncrease)
                }
                this.startTimer();
                setTimeout(() => {
                    this.showItem = false;
                    this.showAnswerForm = true;
                    if (this.answerDuration) {
                        this.startAnswerTimer();
                    }
                }, this.parameters.speed * 1000)
            },
            startTimer () {
                this.$nextTick(() => {
                    if (!this.timer) {
                        this.setTimer();
                    }
                });
            },
            processReply () {
                this.answer = this.answer.replace(/ /g,'').toLowerCase();
                if (this.answer) {
                    this.stopTimer();
                    this.stopAnswerTimer();
                    if (this.answer === this.correctAnswer) {
                        this.correct = true;
                        this.answers.good++;
                        this.lastAnswer.good++;
                        this.items[0] = null;
                        this.items = this.items.filter(element => element)
                        this.changeDistance(this.parameters.distanceIncrease);
                        this.playResultSound('success');
                    } else {
                        this.playResultSound('failure');
                        this.answers.bad++;
                        this.lastAnswer.bad++;
                        if (this.isOlympiad) {
                            this.items[0] = null;
                            this.items = this.items.filter(element => element)
                        }
                    }
                    this.isRunning = false;
                    if (!this.$offline && (this.user.type === 'student' || this.user.type === 'olympiads-student')) {
                        this.sendStat();
                    }
                    if (this.isOlympiad) {
                        this.refreshGame();
                    }
                    if (!this.items.length) {
                        this.finishGame();
                    }
                } else if (this.isOlympiad && this.answer) {
                    this.stopTimer();
                    this.stopAnswerTimer();
                    this.items[0] = null;
                    this.items = this.items.filter(element => element)
                    this.answers.bad++;
                    this.lastAnswer.bad++;
                    if (!this.$offline && (this.user.type === 'student' || this.user.type === 'olympiads-student')) {
                        this.sendStat();
                    }
                    this.refreshGame();
                    if (!this.items.length) {
                        this.finishGame();
                    }
                }
            },
            generateNumbers() {
                for(let index = 0; index < this.parameters.numOfExamples - this.answers.good; index++) {
                    this.items.push(this.getRandomInt(10 ** (this.parameters.difficult.value - 1), 10 ** this.parameters.difficult.value - 1).toString());
                }
            },
            getRandomInt (min, max) {
                return Math.floor(Math.random() * (max - min)) + min;
            },
            changeDistance (value) {
                this.currentPadding = Math.min((this.currentPadding + value), 100);
            },
            refreshGame () {
                this.setTimer();
                this.correct = null;
                this.answer = '';
                this.isRunning = true;
                if (this.lastAnswer.good === 1) {
                    this.lastAnswer.good = 0;
                    this.lastAnswer.bad = 0;
                }
                this.showItem = true;
                this.showAnswerForm = false;
                this.showItemTimeout = setTimeout(() => {
                    this.showItem = false;
                    this.showAnswerForm = true;
                    if (this.answerDuration) {
                        this.startAnswerTimer();
                    }
                }, this.parameters.speed * 1000)
            },
            finishGame () {
                this.gameFinished = true;
                this.stopTimer();
                this.stopAnswerTimer();
                this.sendStat();
            },
            playResultSound(result) {
                if (!this.isOlympiad) {
                    this.resultInstance = this.$createjs.Sound.play(result);
                    this.resultInstance.volume = 0.6;
                }
            },
            refreshGameStatBeforeSend () {
                this.gameStat.attempts = this.answers.good + this.answers.bad;
                this.gameStat.lastAnswer = this.lastAnswer;
                this.gameStat.answers = this.answers.good;
                this.gameStat.percent = this.calculatePercent();
                this.gameStat.isCompleted = this.gameFinished;
                this.gameStat.executionTime = this.time;
                this.gameStat.isCorrect = true;
                this.gameStat.parameters = _.cloneDeep(this.parameters);
            },
            calculatePercent() {
                let total = this.answers.good + this.answers.bad;
                if (total > 0) {
                    return parseInt(this.answers.good / (total) * 100);
                }
                return 0;
            },
            beforeGameRestart () {
                Object.assign(this, DEFAULT_DATA());
            }
        },
    }
</script>

<style lang="scss" scoped>
    @import "@/assets/sass/games/playbox.scss";
    .play-box__game {
        display: flex;
        justify-content: center;
        flex: 1 1 auto;
    }

    .buttons {
        text-align: center;
        padding-bottom: 60px;
    }

    .vision-field-game-container {
        width: 100%;
        display: flex;
        overflow: hidden;
        &__result-container {
            padding: 60px;
            display: flex;
            flex-direction: column;
            align-items: center;
            &__info {
                margin: 20px 0px;
            }
        }
        &__result-image {
            max-height: 360px;
            max-width: 360px;
            @include media($sm) {
                max-width: 450px;
                max-height: 450px;
            }
            vertical-align: middle;
        }
        &__interactive-place {
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            text-align: center;
            flex-wrap: wrap;
            flex-grow: 1;
            flex-shrink: 1;
            @include inset-space($space-base);
        }
        &__game {
            display: flex;
            flex-direction: column;
            height: 100%;
        }
        &__game-info {
            display: flex;
            align-self: flex-end;
        }
        &__game-box {
            min-width: 180px;
            display: flex;
            justify-content: center;
            align-items: center;
            @include text($font-size-32, $font-weight-bold);
            @include media($sm) {
                @include text($font-size-44, $font-weight-bold);
            }
            @include media($md) {
                @include text($font-size-56, $font-weight-bold);
            }
            @include media($lg) {
                @include text($font-size-64, $font-weight-bold);
            }
            @include media($xlg) {
                @include text($font-size-76, $font-weight-bold);
            }
            @include media($xl) {
                @include text($font-size-82, $font-weight-bold);
            }
            @include media($xxl) {
                @include text($font-size-96, $font-weight-bold);
            }
        }
        &__prepare-image {
            display: flex;
            flex-direction: column;
            flex-grow: 1;
            flex-shrink: 1;
            justify-content: center;
            align-items: center;
            @include inset-space($space-base);
        }
        &__prepare-text {
            font-family: Boomboom, serif;
            color: $color-brown-500;
            font-size: 30px;
            white-space: nowrap;

            @include media($sm) {
                font-size: 60px;
            }
        }
        &__answer-form {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
        }
        &__answer-header {
            font-weight: 500;
            font-size: 32px;
            line-height: 38px;
            text-align: center;
            color: #333333;
            @include stack-space($space-small);
        }
        &__answer-body {
            @include stack-space($space-small);
        }
        &__input {
            .cs-input {
                width: 330px;
                max-width: calc(100vw - 75px);
                height: 80px;
                text-align: center;
                @include text($font-size-32, $font-weight-bold);
                @include media($lg) {
                    @include text($font-size-44, $font-weight-bold);
                }
                @media screen and (max-width: 991px) {
                    height: 60px;
                }
                -moz-appearance: textfield;
                &::-webkit-inner-spin-button,
                &::-webkit-outer-spin-button{
                    -webkit-appearance: none;
                    -moz-appearance: none;
                    appearance: none;
                    margin: 0;
                }
            }
        }
        &__game-turtle {
            display: none;
            position: fixed;
            bottom: $space-large;
            right: $space-large;
            left: auto;
            width: 125px;
            @include media($lg) {
                display: block;
            }
            @include media($xlg) {
                width: 175px;
            }
        }
        &__divider {
            border-bottom: 1px solid $color-grey-300;
        }
        &__reaction-image {
            @include stack-space($space-base);
            max-height: 360px;
            @include media($sm) {
                max-height: unset;
            }
        }
        &__reaction-image-container {
            display: none;
            @include media($sm) {
                display: unset;
            }
            @media (min-width: 576px) and (max-width: 768px) {
                order: -1;
                width: 100%;
                display: flex;
                justify-content: center;
            }
        }
        &__reaction-container {
            display: flex;
            flex-direction: column;
            align-items: center;
            flex-grow: 1;
            flex-shrink: 1;
        }
        &__footer-buttons {
            display: flex;
        }
        &__reaction {
            display: flex;
            align-items: center;
            justify-content: space-around;
            text-align: center;
            width: 100%;
            flex-direction: column;
            @include stack-space($space-base);
            @include media($sm) {
                flex-direction: row;
                flex-wrap: wrap;
            }
        }
        &__reaction-side {
            font-weight: 500;
            font-size: 42px;
            line-height: 50px;
            text-align: center;
            color: #FF3D53;
            @media screen and (max-width: 1300px) {
                font-size: 34px
            }
            @media screen and (max-width: 991px) {
                font-size: 22px;
            }
            &--correct {
                color: #6BBD6C;
            }
        }
        &__reaction-count {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            @include text($font-size-44, $font-weight-bold);
            @include media($lg) {
                @include text(75px, $font-weight-bold);
            };
            @include media($xlg) {
                @include text(100px, $font-weight-bold);
            };
        }
    }

    .warning {
        display: table-cell;
        vertical-align: middle;
        text-align: center;
    }

    .router-link {
        margin: 5px
    }

    .play-box__buttons {
        display: flex;
        flex-direction: column;
        margin-top: 20px;
        @include media($sm) {
            margin-top: 25px;
        }
        @include media($lg) {
            flex-direction: row;
        }
    }

    .play-box__button {
        margin: 20px 0;
        @include media($lg) {
            margin: 0 20px;
        }
    }

    .play-box__button:first-child {
        margin-top: 0;
        @include media($lg) {
            margin-left: 0;
        }
    }

    .play-box__button:last-child {
        margin-bottom: 0;
        @include media($lg) {
            margin-right: 0;
        }
    }
</style>
